import { render, staticRenderFns } from "./exam-header.vue?vue&type=template&id=16dfc01c"
import script from "./exam-header.vue?vue&type=script&setup=true&lang=ts"
export * from "./exam-header.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports